import { render, staticRenderFns } from "./LoanApplications.vue?vue&type=template&id=28fbaeee&"
import script from "./LoanApplications.vue?vue&type=script&lang=js&"
export * from "./LoanApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports